import React from 'react';
import NumberFormat from 'react-number-format';

function ParseNumberThousandMedium({ field }: any) {
    return (
        <NumberFormat {...field} thousandSeparator={false} className={'form-know-you-item-input-medium'} decimalScale={0} allowNegative={false}/>
    )
}

export default ParseNumberThousandMedium;